import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Image } from '../../components/_all';
import './identify.scss';


const IdentifySection = ({ payload }) => {
  const { identify } = payload;
  const { t } = useTranslation();

  if (!identify) return null;

  return (
    <section className="identify">
      <div className="identify__container">
        <div className="identify__container--left">
          <h2>{t(identify.title)}</h2>
          {identify.items?.map((item, index) => (
            <div className="identify__container--left--list" key={index}>
              <img src={item.icon} alt={item.alt} />
              <p>
                <b>{t(item.bold)}</b> {t(item.text)}
              </p>
            </div>
          ))}
          {identify.cta && (
            <div className="flex__class--row">
              <a className="button--secondary" href={identify.cta.href}>
                {t(identify.cta.label)}
              </a>
            </div>
          )}
        </div>
        {identify.image && (
          <div className="identify__container--right">
            <img src={identify.image.path} alt={identify.image.alt} />
          </div>
        )}
      </div>
    </section>
  );
};


export default IdentifySection;